import { render, staticRenderFns } from "./CreateEventDialog.vue?vue&type=template&id=b9cdcea8"
import script from "./CreateEventDialog.vue?vue&type=script&lang=js"
export * from "./CreateEventDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports